export default "__VITE_ASSET__7a4e5fff__"